var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"font-weight-bold",attrs:{"target":"_blank","href":_vm.href,"color":"accent","x-large":""}},[_vm._v("🍺 "+_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }